import { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";

interface MonthDropdownProps {
  onChange: (month: string) => void; // returns MM-YYYY
}

export default function MonthDropdown({ onChange }: MonthDropdownProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState<[string, string][]>([]);
  const [selectedKey, setSelectedKey] = useState<string>("");

  const toggle = () => setDropdownOpen((prev) => !prev);

  const formatSelectedKey = (key: string) => {
    const month = key.slice(5, 7);
    const year = key.slice(0, 4);
    return `${month}-${year}`; // "06-2025"
  };

  useEffect(() => {
    const fetchMonths = async () => {
      const serverUrl = localStorage.getItem("serverUrl");
      const APP_TOKEN = localStorage.getItem("appToken");

      if (!serverUrl || !APP_TOKEN) return;

      const url = `${serverUrl}${API.getAllowedMonths}`;
      try {
        const { status, data } = await getData(url, true);
        if (status === 200 && Array.isArray(data?.data) && data.data.length > 0) {
          const monthObject = data.data[0];
          const entries = Object.entries(monthObject) as [string, string][];
          setDropdownOptions(entries);
          if (entries.length > 0) {
            const firstKey = entries[0][0];
            setSelectedKey(firstKey);
            onChange(formatSelectedKey(firstKey)); // pass initial value
          }
        }
      } catch (err) {
        console.error("❌ Failed to fetch months:", err);
      }
    };

    fetchMonths();
  }, []);

  const handleSelect = (key: string) => {
    setSelectedKey(key);
    onChange(formatSelectedKey(key));
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary">
        {dropdownOptions.find(([key]) => key === selectedKey)?.[1] || "Select Month"}
      </DropdownToggle>
      <DropdownMenu>
        {dropdownOptions.map(([key, label]) => (
          <DropdownItem key={key} onClick={() => handleSelect(key)}>
            {label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
